import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DD6D5075-A7F5-4183-9F99-93C295F18B0B
 * name note-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-outline.svg
 * tags
 */
export const NoteOutlineIcon = createSvgIcon(<><path d="M14,10H19.5L14,4.5V10M5,3H15L21,9V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,5V19H19V12H12V5H5Z" /></>, 'NoteOutlineIcon');
export default NoteOutlineIcon